// Rs. Mart POS — English + Hinglish labels (customer-selectable)
export const POS_T = {
  en: {
    pos_title: "Rs. Mart POS", pro: "PRO", store: "Rani Super Market",
    todays_sales: "Today's Sales", this_month: "This Month", bills: "Bills",
    to_receive: "To Receive", to_pay: "To Pay",
    payment_in: "Payment In", payment_out: "Payment Out", pos_billing: "POS Billing", new_sale: "New Sale",
    search_txn: "Search name / bill no / mobile",
    all: "All", sale: "Sale", purchase: "Purchase", credit_sale: "Udhaar",
    no_txns: "No transactions yet", total: "Total", balance: "Balance",
    unpaid: "UNPAID", paid: "PAID", partial: "PARTIAL",
    billing_counter: "Billing Counter", back: "Back",
    current_bill: "Current Bill", customer_phone: "Customer phone", name_optional: "Name (optional)",
    old_due: "Old udhaar", subtotal: "Subtotal", discount: "Discount", taxable: "Taxable", gst: "GST",
    charges: "Charges", round_off: "Round off", pay: "Pay", tap_add: "Tap products to add · F2 = Pay",
    day_close: "Day Close", printer: "Printer", online: "Online", offline: "Offline",
    create_new: "Create new product", sale_rate: "Sale Rate ₹", buy_rate: "Buy Rate ₹", gst_pct: "GST %",
    make_add: "Create & add to bill", no_item: "No item found", search_product: "Scan barcode or search product…",
    complete_print: "Complete & Print", hold: "Hold", clear: "Clear",
    menu: "Menu", held_bills: "Held Bills", no_holds: "No held bills",
    printer_settings: "Printer Settings", sync_now: "Sync now", resume: "Resume",
    transactions: "Transactions", party_details: "Party Details", parties: "Parties",
    no_parties: "No parties yet", record_payment_in: "Payment In (collect)", record_payment_out: "Payment Out (pay supplier)",
    select_party: "Select party", select_supplier: "Select supplier", amount: "Amount", note_opt: "Note (optional)",
    save: "Save", cancel: "Cancel", supplier: "Supplier", payable: "Payable", credit_terms: "Credit terms",
    net_0: "Due now", net_15: "Net 15 days", net_30: "Net 30 days", due_on: "Due", collect_due: "Collect",
  },
  hi: {
    pos_title: "Rs. Mart POS", pro: "PRO", store: "Rani Super Market",
    todays_sales: "Aaj ki Sales", this_month: "Is Mahine", bills: "Bills",
    to_receive: "Lena Hai", to_pay: "Dena Hai",
    payment_in: "Paisa Aaya", payment_out: "Paisa Gaya", pos_billing: "POS Billing", new_sale: "Nayi Sale",
    search_txn: "Naam / bill no / mobile khojein",
    all: "Sab", sale: "Sale", purchase: "Kharid", credit_sale: "Udhaar",
    no_txns: "Abhi koi transaction nahi", total: "Total", balance: "Baaki",
    unpaid: "BAAKI", paid: "CHUKTA", partial: "AADHA",
    billing_counter: "Billing Counter", back: "Wapas",
    current_bill: "Abhi ka Bill", customer_phone: "Customer phone", name_optional: "Naam (optional)",
    old_due: "Purana udhaar", subtotal: "Subtotal", discount: "Chhoot", taxable: "Taxable", gst: "GST",
    charges: "Extra", round_off: "Round off", pay: "Pay", tap_add: "Product tap karke add karein · F2 = Pay",
    day_close: "Din Band", printer: "Printer", online: "Online", offline: "Offline",
    create_new: "Naya product banao", sale_rate: "Sale Rate ₹", buy_rate: "Kharid Rate ₹", gst_pct: "GST %",
    make_add: "Banao & Bill me jodo", no_item: "Koi item nahi mila", search_product: "Barcode scan ya product khojein…",
    complete_print: "Complete & Print", hold: "Hold", clear: "Clear",
    menu: "Menu", held_bills: "Hold Bills", no_holds: "Koi hold bill nahi",
    printer_settings: "Printer Settings", sync_now: "Sync karein", resume: "Wapas kholein",
    transactions: "Transactions", party_details: "Party Details", parties: "Parties",
    no_parties: "Abhi koi party nahi", record_payment_in: "Paisa Aaya (vasool)", record_payment_out: "Paisa Diya (supplier)",
    select_party: "Party chunein", select_supplier: "Supplier chunein", amount: "Rakam", note_opt: "Note (optional)",
    save: "Save karein", cancel: "Cancel", supplier: "Supplier", payable: "Dena Hai", credit_terms: "Udhaar avadhi",
    net_0: "Abhi dena", net_15: "15 din me", net_30: "30 din me", due_on: "Due", collect_due: "Vasool",
  },
};
